import type { RouteRecordRaw } from "vue-router";
import AreasPage from "./AreasPage.vue";
import EditAreaPage from "./EditAreaPage.vue";
import NewAreaPage from "./NewAreaPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/areas",
    children: [
      {
        path: "",
        name: "areas",
        component: AreasPage,
      },
      {
        path: "new",
        name: "newArea",
        component: NewAreaPage,
      },
      {
        path: ":id",
        name: "editArea",
        component: EditAreaPage,
        props: true,
      },
    ],
  },
];

export default routes;
